import React from "react";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import BlueMarker from "../../../../assets/images/markers/blueMarker.png";
import Card from "@material-ui/core/Card";

import * as Constants from "../../../../consts/Constants.js";

import { Coordinate } from '../../../../plas/utils/geographics/models';
import service from '../../../../plas/services/shifter/service';
import alerter from "../../../alerts/alerter"


export default function EventForm({
  eventId,
  onCancel,
  onSave,
  fullWidth
}) {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [event, setEvent] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [location, setLocation] = React.useState(null);

  const markerRef = React.useRef(null)

  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    loadEvent()
  }, []);

  const loadEvent = () => {
    setLoading(true);
    service.api.events.get(eventId, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
        if (onCancel)
          onCancel()
      } else {
        setEvent(response.result);
        setName(response.result.name);
        setDescription(response.result.description);
        setLocation(response.result.location);
        setLoading(false);
      }
    });
  }

  const saveHandler = () => {
    if (event.id) { 
      update()
    } else {
      create();
    }
  }


  const create = () => {
    /*
    setSaving(true)
    service.api.advertisements.create(advertisement, (response) => {
      if (response.result != null) {
        if (onSave)
          onSave(response.result);
      } else {
        alerter.showError(response.error);
      }
      setSaving(false)
    });*/
  }

  const update = () => {
    setSaving(true)
    service.api.events.update(eventId, event, (response) => {
      if (response.result != null) {
        if (onSave)
          onSave(response.result);
      } else {
        alerter.showError(response.error);
      }
      setSaving(false)
    });
  }

  const onChangeDescription = (e) => {
    let value = e.target.value.trim();
    event.description = value ? value : null;
    setDescription(e.target.value);
  }

  const onChangeName = (e) => {
    let value = e.target.value.trim();
    event.name = value ? value : null;
    setName(e.target.value);
  }

  const ColoredLine = ({ color }) => (
      <hr
          style={{
              color: color,
              backgroundColor: color,
              marginTop: 6,
              marginBottom: 16,
              height: 2
          }}
      />
  );

 const markerEventHandlers = {
    dragend() {
      const marker = markerRef.current
      if (marker != null) {
        event.location = new Coordinate({latitude: marker.getLatLng().lat, longitude: marker.getLatLng().lng});
        setLocation(event.location);
      }
    }
  }

  const markerIcon = new L.Icon({
      iconUrl: BlueMarker,
      popupAnchor: [0, -30],
      iconSize: new L.Point(26, 39),
      iconAnchor: [13, 39]
  });


  return(
    <Grid container>
      <Grid item xs={12} style={{ textAlign: "center"}}>
        { loading ? (
          <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
        ):(
          <Grid container spacing={2}>
            <Grid item xs={false} md={ fullWidth ? false : 2} />
              <Grid item xs={12} md={ fullWidth ? 12 : 8} >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                <p style={{ fontSize: '28px', textAlign: 'left'}}>
                  Datos del evento
                </p>
                <ColoredLine color="gray"/>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={8}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          id="name"
                          label="Nombre del evento"
                          name="name"
                          onChange={onChangeName}
                          disabled={saving}
                          value={name}
                          fullWidth
                          placeholder="Nombre del evento"/>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          variant="outlined"
                          id="body"
                          required
                          disabled={saving}
                          label="Descripción del evento"
                          name="body"
                          multiline
                          minRows={3}
                          maxRows={6}
                          value={description}
                          onChange={onChangeDescription}
                          fullWidth
                          placeholder="Descripción del evento..."/>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Card style={{ height: "100%" }} elevation={0}>
                      <MapContainer 
                        style={{
                          height: "400px",
                          width: "100%",
                          overflow: "hidden",
                          zIndex: '399'
                        }}
                        center={location ? {lat: location.latitude, lng: location.longitude} : {lat: Constants.LATITUD_AYACUCHO, lng: Constants.LONGITUD_AYACUCHO}}
                        zoom={14}
                        scrollWheelZoom={true}>
                        <TileLayer
                          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                        { location? 
                          (<Marker
                            draggable={!saving}
                            icon={markerIcon}
                            eventHandlers={markerEventHandlers}
                            position={{lat: location.latitude, lng: location.longitude}}
                            ref={markerRef}>
                          </Marker>) : (null)
                        }
                      </MapContainer>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
                <Grid item xs={12}>
                  <ColoredLine color="gray"/>
                  <Grid container spacing={2}>
                    <Grid item xs={true}/>
                    <Grid item>
                      { onCancel && (
                        <ThemeProvider theme={theme}>
                          <Button 
                            disabled={saving} 
                            startIcon={<CancelIcon/>} 
                            variant="contained" 
                            onClick={() => onCancel()}>
                            Cancelar
                          </Button>
                        </ThemeProvider>
                      )}
                    </Grid>
                    <Grid item>
                      { onSave && (
                        <LoadingButton
                          disabled={!event.isValid()}
                          loadingPosition="start"
                          startIcon={<DoneIcon />}
                          loading={saving}
                          variant="contained"
                          onClick={saveHandler}>
                          <b>{ event.id ? "Guardar" : "Crear" }</b>
                        </LoadingButton>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={false} md={ fullWidth ? false : 2} />
          </Grid>
        )}
      </Grid>
    </Grid>
  )

}
